import ManagementSearch from "src/components/pages/Management/ManagementSearch/ManagementSearch";
import ManagementTable from "src/components/pages/Management/ManagementTable/ManagementTable";
import useRestricted from "src/components/pages/Management/useRestricted";
import Breadcrumbs from "src/components/shared/Breadcrumbs/Breadcrumbs";
import { useGetApi } from "src/hooks";
import { ButtonWrapper } from "src/pages/Settings/AccountDetails/AccountDetails.styled";
import { useSelector } from "src/redux/hooks";
import { PageContainer } from "src/styled";

const mapClients = (data: any) => {
  // let list: IClient[] = [];
  // if (data?.data?.content?.list) {
  //   list = data.data.content.list.map((el: IClient) => ({
  //     ...el,
  //     active: el.active,
  //   }));
  // }
  return { ...data?.data?.content, list: data?.data?.content?.list ?? [] };
};

const Clients = () => {
  const { clientAdmin, isRestrictedToYacht, isRestrictedToOrg } = useSelector(
    state => state.permsSlice,
  );
  useRestricted([clientAdmin, isRestrictedToYacht, isRestrictedToOrg]);

  const { data, isLoading, refetch } = useGetApi({
    request: "get-management",
    body: { _sect: "_clients" },
    mapper: mapClients,
  });

  return (
    <PageContainer>
      <Breadcrumbs border={false}>
        <ButtonWrapper>
          <ManagementSearch
            section={"_clients"}
            refetch={refetch}
            currentRequestParams={{ _sect: "_clients" }}
          />
        </ButtonWrapper>
      </Breadcrumbs>
      <ManagementTable
        section="_clients"
        data={data?.list ?? []}
        loading={isLoading}
      />
    </PageContainer>
  );
};

export default Clients;
